export var isLastPage = function (limit, offset, size) { return ((offset + limit) >= size); };
export var isFirstPage = function (offset) { return offset <= 0; };
export var nextPage = function (limit, offset, size, updatePage) {
    if (!isLastPage(limit, offset, size)) {
        updatePage(limit, offset + limit);
    }
};
export var previousPage = function (limit, offset, updatePage) {
    if (!isFirstPage(offset)) {
        updatePage(limit, offset - limit);
    }
};
export var firstPage = function (limit, offset, updatePage) {
    if (!isFirstPage(offset)) {
        updatePage(limit, 0);
    }
};
export var lastPage = function (limit, offset, size, updatePage) {
    if (!isLastPage(limit, offset, size)) {
        updatePage(limit, Math.floor((size - 1) / limit) * limit);
    }
};
//# sourceMappingURL=utils.js.map